import React from "react";

const TicketsInformation = (props) => {
  return (
    <div className="d-none d-md-flex flex-column container rounded p-0 mx-auto mt-15 text-right">
      <div
        className=" w-100 rounded d-flex "
        style={{ backgroundColor: "gray" }}
      >
        <div
          className="d-flex justify-content-right col-md-11 col-lg-9"
          style={{ height: "3.5rem", alignItems: "center" }}
        >
          <h5 className="text-white col-3">
            <b>شماره سفارش</b>
          </h5>
          <h5 className="text-white col-3">
            <b>مبدا</b>
          </h5>
          <h5 className="text-white col-3">
            <b>مقصد</b>
          </h5>
          <h5 className="text-white col-3">
            <b>تاریخ حرکت</b>
          </h5>
        </div>
      </div>
    </div>
  );
};

export default TicketsInformation;
